import { formatSessionCost } from '@bbkAdminComponents/settings/plans/components/ui';
import type { PlanPrice } from '@bbkAdminRedux/rtkq/checkout.slice';
import { getPeriodLong } from '@bbkAdminRedux/rtkq/checkout.slice';
import { PLANS } from '@bbkAdminRedux/rtkq/checkout.plans';

const essentialBenefits = (planPrice: PlanPrice) => [
  '2 cancel experiences',
  `Up to ${planPrice.included_session_limit} retention sessions / mo`,
  `${formatSessionCost(planPrice.overage_price)} per retention session beyond ${
    planPrice.included_session_limit
  } / mo`,
  `Paid ${getPeriodLong(planPrice.period)} via credit card`,
  `Auto-renews on your ${getPeriodLong(planPrice.period)} anniversary`,
  'Cancel online at anytime',
];
const performanceBenefits = (planPrice: PlanPrice) => [
  'Optimize churn with smart save workflows',
  'Churn trends + insights',
  'Advanced deflection',
  'Brand manager',
  'Targeting & testing with ML',
  'CRM + Data + Channels',
  'Attribution + customized offers',
  'Annual session packs',
];
const enterpriseBenefits = (planPrice: PlanPrice) => [
  'Prevent churn and maximize LTV with ML',
  'LTV cohorts',
  'Predictive defelction',
  'Multi-brand management',
  'Multi-model ML',
  'Custom API',
  'Support for custom systems',
  'Custom session packs',
];

export const getBenefits = (planPrice: PlanPrice | undefined) => {
  if (!planPrice) return [];
  switch (planPrice.planName) {
    case PLANS.ESSENTIALS:
      return essentialBenefits(planPrice);
    case PLANS.PERFORMANCE:
      return performanceBenefits(planPrice);
    case PLANS.ENTERPRISE:
      return enterpriseBenefits(planPrice);
    default:
      return [];
  }
};

export const essentialBenefitsChoosePlan = [
  'Start cutting voluntary subscriber churn today',
  'Get started in minutes',
  'Branding and personalization',
  'A/B testing',
  'Stripe, Chargebee, Recurly integrations',
];

export const performanceBenefitsChoosePlan = [
  'For growing subscription business looking to maximize retention',
  'Everything in Essentials plus:',
  'Audience and offer targeting',
  'Multivariate testing',
  'Technical account management',
];

export const enterpriseBenefitsChoosePlan = [
  'For at-scale organizations seeking a flexible and secure solution',
  'Everything in Performance plus:',
  'Unlimited experiences and models',
  'Multiple brands and sub-accounts',
  'Proactive performance management',
];
